import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAdminDataStore, { selectCurrentGroupData } from "../../../../store/adminData/adminData";
import { getWebsiteConfig } from "../../../../services/firebaseService/endPoints/admin/website";
import ChantButton from "../../../../CommonComponents/ChantButton/ChantButton";
import MilestoneStatusBadge from "./MilestoneStatusBadge";

const MilestonePublishGroup = () => {
  const navigate = useNavigate();
  const groupData = useAdminDataStore(selectCurrentGroupData);
  const [isPublished, setIsPublished] = useState(false);

  useEffect(() => {
    if (!groupData?.id) return;
    getWebsiteConfig(groupData.id)
      .then((data) =>
        setIsPublished(data?.directoryStatus === "live" && !!data?.showGroup),
      )
      .catch((err) => console.error("Failed to fetch website config:", err));
  }, [groupData?.id]);

  return (
    <div className="milestone-card">
      <div className="milestone-card-top">
        <div className="milestone-card-header">
          <span className="milestone-number">Milestone 03</span>
          <MilestoneStatusBadge status={isPublished ? "COMPLETE" : "IN PROGRESS"} />
        </div>
        <h3 className="milestone-title">Publish Your Group</h3>
        <p className="milestone-description">
          Publish {groupData?.groupName} in the global supporter directory
          allowing fans to find you and your events. This can also serve as a
          free group Website.
        </p>
      </div>

      <div className="milestone-card-body">
        <div className="milestone-action-bottom">
          <ChantButton
            type="primary"
            style={{ width: "100%" }}
            onClick={() =>
              isPublished
                ? window.open(
                    `https://directory.chant.fan/details/${groupData?.id}`,
                    "_blank",
                    "noopener,noreferrer",
                  )
                : navigate("/admin/directory/groupListing")
            }
          >
            {isPublished ? "View Directory" : "Publish your group"}
          </ChantButton>
        </div>
      </div>
    </div>
  );
};

export default MilestonePublishGroup;
